module.exports = __webpack_public_path__ + "static/img/content.eecb523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content.png
// module id = rfwo
// module chunks = 128